import { useCallback } from 'react';

import ToastComponent, { IToastType } from '../components/Toast/ToastComponent';
import { useCancelEbookSubmissionItemMutation } from '../core/graphql/operation-hooks';

const useMutationCancelEbookSubmissionItem = () => {
  const [mutate, { loading }] = useCancelEbookSubmissionItemMutation();

  const cancelEbookSubmissionItem = useCallback(
    async (ebookSubmissionItemId: string) => {
      try {
        const res = await mutate({
          variables: { ebookSubmissionItemId },
          refetchQueries: ['EbookSubmissionItems', 'EbookSubmission'],
        });
        if (res.data?.cancelEbookSubmissionItem?.success) {
          return { success: true };
        } else {
          ToastComponent({ label: 'Cancel failed.', type: IToastType.ERROR });
          return { success: false };
        }
      } catch (err) {
        ToastComponent({ label: 'An error occurred.', type: IToastType.ERROR });
        return { success: false };
      }
    },
    [mutate],
  );

  return { cancelEbookSubmissionItem, isCancellingEbookSubmissionItem: loading };
};

export default useMutationCancelEbookSubmissionItem;
